import React from "react";
import { useNavigate } from "react-router-dom";
import notfound from "../../images/404.svg";
import { useCookies } from "react-cookie";

export default function NotFound() {
  const navigate = useNavigate();
  const [cookies] = useCookies(["reebukToken"]);

  const handleNavigate = () => {
    if (cookies.reebukToken) {
      navigate("/dashboard");
    } else {
      navigate("/auth/Login");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center p-4">
      <img src={notfound} alt="404" className="w-64 sm:w-80 md:w-96" />
      <h4 className="text-xl sm:text-2xl md:text-3xl font-semibold mt-4">
        Oops! The page you were looking for doesn't exist.
      </h4>
      <p className="mt-4">
        <button
          onClick={() => handleNavigate()}
          className="px-6 py-2 bg-[#284184] text-white text-lg rounded-lg transition-all"
        >
          Go to home page
        </button>
      </p>
    </div>
  );
}
